import axios from 'axios'
import router from '../router'
import { Message, Notification } from 'element-ui'

const origin = window.origin
const server = axios.create({
    // baseURL: '/api',
    baseURL: origin + '/cost',
    // baseURL: 'http://114.215.146.204:8000/',
    // baseURL: 'https://www.dxcjpt.com/cost/',
    // baseURL: 'http://172.16.0.139:8000/',
    // baseURL: 'http://172.16.0.32:8000/',
    // baseURL: 'http://172.16.0.115:8000/',
    timeout: 10000,
    // headers: { 'Authorization': localStorage.getItem('token_type') + '123 ' + localStorage.getItem('access_token') }
})

// code 检查(第一层) 用于检查接口系统级错误
const codeCheck = (response, error) => {
    // console.log(response)
    switch (response.data.code) {
        case '0': // 正常返回
            return true
        case '-1': // 请求失败
            Message({
                message: response.data.msg,
                type: 'error'
            })
            return false
        case 2:
            // 未登录
            router.push({ name: 'login' })
            return false
        case 3:
            // 没有权限
            return false
        case 4:
            // 业务处理错误
            return false
        default:
            console.log('接口错误 code: ' + response.data.code)
            return false
    }
}

server.interceptors.response.use(
    response => {
        // 文件流处理
        if (response.config.responseType === 'blob') {
            return Promise.resolve(response)
        }
        // console.log(typeof response.config.headers.name === 'undefined')
        if (codeCheck(response)) {
            // console.log(response)
            // 接口类型检查, 用于区分操作接口与数据接口, 数据接口直接返回数据, 操作接口返回操作结果
            switch (response.data.operationType) {
                case '1':
                    const res = response.data
                    return Promise.resolve(res)
                case '2':
                    let rep = {
                        operationCode: response.data.operationCode,
                        message: response.data.msg,
                        data: response.data.data,
                        messageShow: true
                    }
                    switch (response.data.operationCode) {
                        case 1:
                            rep.type = 'success'
                            break
                        case 0:
                            rep.type = 'error'
                            break
                        default:
                            rep.type = 'error'
                            res.message = '错误!!operationCode:' +  response.data.operationCode
                    }
                    if (typeof response.config.headers.name !== 'undefined') {
                        if (response.config.headers.name === 'login') {
                            Notification({
                                title: '提示',
                                message: response.data.msg,
                                type: rep.type,
                                duration: 2000
                            })
                        }
                    } else {
                        if (typeof response.config.headers.duration !== 'undefined') {
                            Message({
                                message: response.data.msg,
                                type: rep.type,
                                showClose: true,
                                duration: parseInt(response.config.headers.duration)
                            })
                        } else {
                            Message({
                                message: response.data.msg,
                                type: rep.type,
                                showClose: true,
                                duration: 2000
                            })
                        }
                    }
                    return Promise.resolve(rep)
                default:
                    break
            }
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        // console.log(error)
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    Message({
                        message: '当前登录信息已失效，清重新登录',
                        type: 'warning',
                        showClose: true,
                        duration: 1000
                    })
                    router.push({ name: 'login' })
                    break
                case 400:
                    Message({
                        message: '接口错误400',
                        type: 'error',
                        showClose: true,
                        duration: 1000
                    })
                    break
                default:
                    Message({
                        message: '系统错误或超时, 请联系系统管理员或稍后重试',
                        type: 'error'
                    })
            }
        } else {
            if (error.message === 'uploadCancel') {
            } else {
                Message({
                    message: '访问超时, 请联系系统管理员',
                    type: 'error',
                    showClose: true,
                    duration: 1000
                })
            }
        }

        return Promise.reject(error)
    }
)

export default server



// WEBPACK FOOTER //
// ./src/api/server.js